import { defineMessages } from 'react-intl';

export const messages: {
	betweenDate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	exactDate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	maximumDate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	minimumDate: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	betweenDate: {
		id: 'proforma-form-renderer.common.utils.validators.date.between-date',
		defaultMessage: 'The date must be between {minimum, date, medium} and {maximum, date, medium}.',
		description: 'Validation message for field with date between a range.',
	},
	exactDate: {
		id: 'proforma-form-renderer.common.utils.validators.date.exact-date',
		defaultMessage: 'The date must be exactly {date, date, medium}.',
		description: 'Validation message for field with exact date.',
	},
	maximumDate: {
		id: 'proforma-form-renderer.common.utils.validators.date.maximum-date',
		defaultMessage: 'The date must be on or before {maximum, date, medium}.',
		description: 'Validation message for field with maximum date.',
	},
	minimumDate: {
		id: 'proforma-form-renderer.common.utils.validators.date.minimum-date',
		defaultMessage: 'The date must be on or after {minimum, date, medium}.',
		description: 'Validation message for field with minimum date.',
	},
});
